export const Pronounciation = [{
  letter: 'A a',
  pronounciation: 'a',
  phoneme: '[a]',
  link: 'https://en.wikipedia.org/wiki/Open_front_unrounded_vowel',
  name: 'Open Front Unrounded Vowel'
}, {
  letter: 'An an',
  pronounciation: 'an',
  phoneme: '[ã]',
  link: 'https://en.wikipedia.org/wiki/Nasal_vowel',
  name: 'Nasal Vowel'
}, {
  letter: 'B b',
  pronounciation: 'be',
  phoneme: '[b]',
  link: 'https://en.wikipedia.org/wiki/Voiced_bilabial_plosive',
  name: 'Voiced Bilabial Plosive'
}, {
  letter: 'Ch ch',
  pronounciation: 'che',
  phoneme: '[ʃ]',
  link: 'https://en.wikipedia.org/wiki/Voiceless_postalveolar_fricative',
  name: 'Voiceless Postalveolar Fricative'
}, {
  letter: 'D d',
  pronounciation: 'de',
  phoneme: '[d]',
  link: 'https://en.wikipedia.org/wiki/Voiced_dental_and_alveolar_plosives',
  name: 'Voiced Dental and Alveolar Plosives'
}, {
  letter: 'Dj dj',
  pronounciation: 'dje',
  phoneme: '[dʒ]',
  link: 'https://en.wikipedia.org/wiki/Voiced_postalveolar_affricate',
  name: 'Voiced Postalveolar Affricate'
}, {
  letter: 'E e',
  pronounciation: 'e',
  phoneme: '[e]',
  link: 'https://en.wikipedia.org/wiki/Close-mid_front_unrounded_vowel',
  name: 'Close-mid Front Unrounded Vowel'
}, {
  letter: 'È è',
  pronounciation: 'è',
  phoneme: '[ɛ]',
  link: 'https://en.wikipedia.org/wiki/Open-mid_front_unrounded_vowel',
  name: 'Open-mid Front Unrounded Vowel'
}, {
  letter: 'En en',
  pronounciation: 'en',
  phoneme: '[ẽ]',
  link: 'https://en.wikipedia.org/wiki/Open_front_vowel',
  name: 'Open Front Vowel'
}, {
  letter: 'F f',
  pronounciation: 'èf',
  phoneme: '[f]',
  link: 'https://en.wikipedia.org/wiki/Voiceless_labiodental_fricative',
  name: 'Voiceless Labiodental Fricative'
}, {
  letter: 'G g',
  pronounciation: 'ge',
  phoneme: '[g]',
  link: 'https://en.wikipedia.org/wiki/Voiced_velar_plosive',
  name: 'Voiced Velar Plosive'
}, {
  letter: 'H h',
  pronounciation: 'hach',
  phoneme: '[h]',
  link: 'https://en.wikipedia.org/wiki/Voiceless_glottal_fricative',
  name: 'Voiceless Glottal Fricative'
}, {
  letter: 'I i',
  pronounciation: 'i',
  phoneme: '[i]',
  link: 'https://en.wikipedia.org/wiki/Close_front_unrounded_vowel',
  name: 'Close Front Unrounded Vowel'
}, {
  letter: 'J j',
  pronounciation: 'ji',
  phoneme: '[ʒ]',
  link: 'https://en.wikipedia.org/wiki/Voiced_postalveolar_fricative',
  name: 'Voiced Postalveolar Fricative'
}, {
  letter: 'K k',
  pronounciation: 'ka',
  phoneme: '[k]',
  link: 'https://en.wikipedia.org/wiki/Voiceless_velar_plosive',
  name: 'Voiceless Velar Plosive'
}, {
  letter: 'L l',
  pronounciation: 'èl',
  phoneme: '[l]',
  link: 'https://en.wikipedia.org/wiki/Voiced_dental,_alveolar_and_postalveolar_lateral_approximants',
  name: 'Voiced Dental, Alveolar and Postalveolar Lateral Approximants'
}, {
  letter: 'M m',
  pronounciation: 'èm',
  phoneme: '[m]',
  link: 'https://en.wikipedia.org/wiki/Voiced_bilabial_nasal',
  name: 'Voiced Bilabial Nasal'
}, {
  letter: 'N n',
  pronounciation: 'èn',
  phoneme: '[n]',
  link: 'https://en.wikipedia.org/wiki/Voiced_dental,_alveolar_and_postalveolar_nasals',
  name: 'Voiced Dental, Alveolar and Postalveolar Nasals'
}, {
  letter: 'ng',
  pronounciation: 'èng',
  phoneme: '[ŋ]',
  link: 'https://en.wikipedia.org/wiki/Voiced_velar_nasal',
  name: 'Voiced Velar Nasal'
}, {
  letter: 'O o',
  pronounciation: 'o',
  phoneme: '[o]',
  link: 'https://en.wikipedia.org/wiki/Close-mid_back_rounded_vowel',
  name: 'Close-mid Back Rounded Vowel'
}, {
  letter: 'Ò ò',
  pronounciation: 'ò',
  phoneme: '[ɔ]',
  link: 'https://en.wikipedia.org/wiki/Open-mid_back_rounded_vowel',
  name: 'Open-mid Back Rounded Vowel'
}, {
  letter: 'On on',
  pronounciation: 'on',
  phoneme: '[õ]',
  link: 'https://en.wikipedia.org/wiki/Nasal_vowel',
  name: 'Nasal Vowel'
}, {
  letter: 'Ou ou',
  pronounciation: 'ou',
  phoneme: '[u]',
  link: 'https://en.wikipedia.org/wiki/Close_back_rounded_vowel',
  name: 'Close Back Rounded Vowel'
}, {
  letter: 'P p',
  pronounciation: 'pe',
  phoneme: '[p]',
  link: 'https://en.wikipedia.org/wiki/Voiceless_bilabial_plosive',
  name: 'Voiceless Bilabial Plosive'
}, {
  letter: 'R r',
  pronounciation: 'èr',
  phoneme: '[ɹ]',
  link: 'https://en.wikipedia.org/wiki/Voiced_alveolar_and_postalveolar_approximants',
  name: 'Voiced Alveolar and Postalveolar Approximants'
}, {
  letter: 'S s',
  pronounciation: 'ès',
  phoneme: '[s]',
  link: 'https://en.wikipedia.org/wiki/Voiceless_alveolar_fricative',
  name: 'Voiceless Alveolar Fricative'
}, {
  letter: 'T t',
  pronounciation: 'te',
  phoneme: '[t]',
  link: 'https://en.wikipedia.org/wiki/Voiceless_dental_and_alveolar_plosives',
  name: 'Voiceless Dental and Alveolar Plosives'
}, {
  letter: 'Tj tj',
  pronounciation: 'tje',
  phoneme: '[tʃ]',
  link: 'https://en.wikipedia.org/wiki/Voiceless_postalveolar_affricate',
  name: 'Voiceless Postalveolar Affricate'
}, {
  letter: 'V v',
  pronounciation: 've',
  phoneme: '[v]',
  link: 'https://en.wikipedia.org/wiki/Voiced_labiodental_fricative',
  name: 'Voiced Labiodental Fricative'
}, {
  letter: 'W w',
  pronounciation: 'doubve',
  phoneme: '[w]',
  link: 'https://en.wikipedia.org/wiki/Voiced_labial%E2%80%93velar_approximant',
  name: 'Voiced Labial-velar Approximant'
}, {
  letter: 'Y y',
  pronounciation: 'igrèk',
  phoneme: '[j]',
  link: 'https://en.wikipedia.org/wiki/Voiced_palatal_approximant',
  name: 'Voiced Palatal Approximant'
}, {
  letter: 'Z z',
  pronounciation: 'zèd',
  phoneme: '[z]',
  link: 'https://en.wikipedia.org/wiki/Voiced_alveolar_fricative',
  name: 'Voiced Alveolar Fricative'
},
];
